const NO_SPECIAL_CHAR_REGEX = /[^a-zA-Z0-9]/g;

class NoSpecialCharFormatter {
  constructor() {
    this.preFormat = true;
  }

  static tryParse(format) {
    return format === 'no-special-char' || format === 'no-special-characters' ? new NoSpecialCharFormatter() : null;
  }

  apply(value) {
    if (!value) return '';

    return value.toString().replace(NO_SPECIAL_CHAR_REGEX, '');
  }

  parse(value) {
    return value;
  }
}

export default NoSpecialCharFormatter;
